import styled from 'styled-components'
import study from '../../assets/icons/study.svg'
import { BLUE_PRINCIPAL, GREY_DARK, GREY_LIGHTS } from '../../utils/colors'

export const Container = styled.div`
  padding: 30px;
  padding-bottom: 62px;
  border-bottom: 1px solid ${GREY_LIGHTS};

  .small-info {
    font-size: 12px;
    line-height: 26px;
    color: ${GREY_DARK};
  }

  .large-info {
    font-weight: bold;
    font-size: 24px;
    line-height: 32px;
    color: ${BLUE_PRINCIPAL};
    margin-bottom: 35px;
  }

  .studies {
    color: transparent;
    display: flex;
    flex-wrap: wrap;

    * {
      display: block;
      width: 0;
      overflow: hidden;
    }

    a {
      margin-top: 18px;
      color: transparent;
      display: block;
      width: 44.16px;
      height: 31px;
      margin-right: 18px;
      margin-bottom: 10px;
      position: relative;
      &:before {
        content: '';
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        position: absolute;
        background-image: url(${study});
        background-repeat: no-repeat;
        background-position: center center;
      }
    }
  }

  .applied_rule_content {
    margin-bottom: 35px;
    font-size: 18px;
    line-height: 26px;
    color: ${GREY_DARK};
    text-align: justify;

    ul {
      margin-left: 12px;
      list-style: inside;
    }
  }
`
